import { Button, Flex, Form, Input, Popconfirm, notification } from "antd";
import { useState } from "react";
import type { CSSProperties } from "react";
import { postRequest, getRequest } from "../../../api/httpRequest";
import { docsStore } from "../../../store/admissions/docsStore";

const refreshContracts = async () => {
    const { setDocs } = docsStore.getState();
    try {
        const response = await getRequest("/server/proxy/contracts/getContracts");
        if (response.data?.length > 0) {
            setDocs(response.data);
        } else {
            setDocs([]);
        }
    } catch {
        /* список обновится при следующем заходе */
    }
};

export interface ContractRejectButtonProps {
    contractId: string;
    /** false — кнопка активна (при отображении) */
    disabled: boolean;
    onSuccess?: () => void;
    /** Как у соседних кнопок в карточке */
    flexStyle?: CSSProperties["flex"];
}

export function ContractRejectButton({ contractId, disabled, onSuccess, flexStyle }: ContractRejectButtonProps) {
    const [api, contextHolder] = notification.useNotification();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [cancelComment, setCancelComment] = useState(false);

    const handleCancelAccept = () => {
        const reason = form.getFieldValue("reason");
        if (reason === undefined || reason === "") {
            setCancelComment(true);
            return;
        }
        setCancelComment(false);
        postRequest("/server/proxy/contracts/CancellAccept", {
            contractId,
            comment: reason,
        })
            .then(() => {
                api.success({ message: "Документ успешно отозван", duration: 2 });
                setOpen(false);
                form.resetFields();
                void refreshContracts();
                onSuccess?.();
            })
            .catch(() => {
                api.error({ message: "Ошибка отзыва документа", duration: 2 });
            });
    };

    return (
        <>
            {contextHolder}
            <Popconfirm
                title="Укажите причину отклонения договора"
                description={() => (
                    <Flex justify="center" align="center">
                        <Form
                            style={{ width: "100%", margin: "16px 0" }}
                            name={`cancel-reason-${contractId}`}
                            form={form}
                            labelAlign="left"
                            requiredMark={false}
                        >
                            <Form.Item
                                style={{ width: "100%", margin: 0 }}
                                name="reason"
                                hasFeedback
                                validateStatus={cancelComment ? "error" : ""}
                                rules={[
                                    {
                                        required: true,
                                        message: "Укажите причину отклонения договора",
                                    },
                                ]}
                            >
                                <Input style={{ width: "100%" }} />
                            </Form.Item>
                        </Form>
                    </Flex>
                )}
                open={open}
                onOpenChange={(next) => {
                    if (!disabled) {
                        setOpen(next);
                    }
                }}
                onConfirm={handleCancelAccept}
                onCancel={() => {
                    setOpen(false);
                    setCancelComment(false);
                }}
            >
                <Button danger disabled={disabled} style={{ flex: flexStyle }}>
                    Отклонить договор
                </Button>
            </Popconfirm>
        </>
    );
}
